import { render, staticRenderFns } from "./YamaBanner.vue?vue&type=template&id=3381d1be&scoped=true&"
import script from "./YamaBanner.vue?vue&type=script&lang=js&"
export * from "./YamaBanner.vue?vue&type=script&lang=js&"
import style0 from "./YamaBanner.vue?vue&type=style&index=0&id=3381d1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381d1be",
  null
  
)

export default component.exports